import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Subnav from 'components/Subnav';
import routes from '../../routes';

import './ProfileSubnav.styles.scss';

type ProfileSubnavProps = {
  className?: string;
  isBossMode?: boolean;
};

const ProfileSubnav: React.FC<ProfileSubnavProps> = (props) => {
  const { className, isBossMode } = props;

  const { t } = useTranslation();

  const links = useMemo(
    () =>
      routes
        .filter((r) => r.labelId && (!isBossMode || r.labelId !== 'settings'))
        .map(({ path, labelId, ...rest }) => ({
          label: t(labelId),
          to: path,
          ...rest,
        })),
    [isBossMode, t],
  );

  const classes = classNames('profile-subnav', className);

  return (
    <div className={classes}>
      <Subnav links={links} />
    </div>
  );
};

export default ProfileSubnav;
